import React from 'react'
import { useAbundanceEngineViewByPathName } from '../../../api/abundanceEngine'
import AbundanceParser from '../../../abundanceEngine/AbundanceParser'

const AddAccountWrapper = () => {
  const { data: viewData } = useAbundanceEngineViewByPathName('manual-account-entry')
  if (!viewData?.view?.jsxView) {
    return null
  }
  return (
    <AbundanceParser
      jsx={viewData?.view?.jsxView}
      jsxComponentsDefaultProps={viewData.defaultProps}
    />
  )
}

export default AddAccountWrapper
